<template>
  <div
    v-if="environment !== 'production'"
    class="environment-badge"
    :class="badgeClass"
    :title="`Ambiente: ${environmentLabel}`"
  >
    <span class="badge-text">{{ environmentLabel }}</span>
  </div>
</template>

<script>
import {
  detectEnvironment,
  getEnvironmentLabel,
  getEnvironmentClasses
} from '@/util/EnvironmentUtils'

export default {
  name: 'EnvironmentBadge',
  computed: {
    environment() {
      return detectEnvironment()
    },
    environmentLabel() {
      return getEnvironmentLabel(this.environment)
    },
    badgeClass() {
      return getEnvironmentClasses(this.environment)
    }
  }
}
</script>

<style lang="scss" scoped>
.environment-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-right: 8px;
  margin-left: 4px;
  opacity: 0.85;
  transition: opacity 0.2s ease;
  align-self: center;

  &:hover {
    opacity: 1;
  }

  .badge-text {
    line-height: 1.2;
  }

  &.env-dev {
    background-color: rgba(34, 197, 94, 0.15);
    color: #16a34a;
    border: 1px solid rgba(34, 197, 94, 0.3);
  }

  &.env-staging {
    background-color: rgba(251, 191, 36, 0.15);
    color: #d97706;
    border: 1px solid rgba(251, 191, 36, 0.3);
  }

  &.env-prod {
    background-color: rgba(107, 114, 128, 0.15);
    color: #6b7280;
    border: 1px solid rgba(107, 114, 128, 0.3);
  }
}

// Ajustes para tema escuro
.d-theme-dark-light-bg .environment-badge {
  &.env-dev {
    background-color: rgba(34, 197, 94, 0.2);
    color: #4ade80;
    border-color: rgba(34, 197, 94, 0.4);
  }

  &.env-staging {
    background-color: rgba(251, 191, 36, 0.2);
    color: #fbbf24;
    border-color: rgba(251, 191, 36, 0.4);
  }

  &.env-prod {
    background-color: rgba(107, 114, 128, 0.2);
    color: #9ca3af;
    border-color: rgba(107, 114, 128, 0.4);
  }
}
</style>

